import styled from "@emotion/styled";
import { SessionSentBadgeColor } from "./session-sent-badge.types";
import { Theme } from "@emotion/react";

type StyledContainerProps = {
  color?: SessionSentBadgeColor;
};

export const StyleContainerPlaceholder = styled.div`
  height: 24px;
`;

export const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  color: ${({ color, theme }) => getColor(theme, color)};
  gap: ${({ theme }) => theme.spacing["1"]};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  padding: ${({ theme }) => theme.spacing["1"]} ${({ theme }) => theme.spacing["2"]};
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const IconContainer = styled.div`
  height: 16px;
`;

const getColor = (theme: Theme, color?: SessionSentBadgeColor) => {
  switch (color) {
    case SessionSentBadgeColor.Green:
      return theme.colors.success;
    default:
      return theme.colors.text.secondary;
  }
};
